import type { FC } from 'react';
import type { TGlobalCompensationBonusesProps } from '@components/Organisms/GlobalCompensation/GlobalCompensation.types';
import { GlobalCompensationDetailsItem } from '@components/Organisms/GlobalCompensation/_partials/GlobalCompensationDetailsItem';
import { DETAILS_ITEMS_TYPES } from '@components/Organisms/GlobalCompensation/_constants/bonuses-and-benefits.constants';
import { getBonusesSubTotal } from '@components/Organisms/GlobalCompensation/_helpers/bonuses-and-benefits';
import { useTranslation } from 'react-i18next';

export const GlobalCompensationBonuses: FC<TGlobalCompensationBonusesProps> = ({
  annualSalary,
  bonuses,
}) => {
  const { t } = useTranslation('', {
    keyPrefix: 'globalCompensation.compensationPackage',
  });

  const bonusesSubTotal = getBonusesSubTotal({
    annualSalary,
    bonuses,
  });

  if (bonuses.length === 0) {
    return null;
  }

  return (
    <GlobalCompensationDetailsItem
      itemType={DETAILS_ITEMS_TYPES.BONUSES_AND_BENEFITS}
      value={bonusesSubTotal.toString()}
    >
      <ul className="c-global-compensation-bonuses">
        {bonuses.map((bonus, bonusIndex) => (
          <li className="c-global-compensation-bonuses__item" key={bonusIndex}>
            {bonus.details ??
              t('details.bonusDefaultDetail', { index: bonusIndex + 1 })}
          </li>
        ))}
      </ul>
    </GlobalCompensationDetailsItem>
  );
};
